import Flickity from "flickity";

// require('flickity-fade');

class CustomFlickity {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-custom-flickity="scope"]',
			button: '[data-flickity-button]',
			verticalNav: '[data-flickity-cell-nav]',
			cell: '[data-flickity-cell]',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scopeVerticalNav = this.$scope.find(this.config.verticalNav);
		this.addEventListeners();

		this.$scope.each((index, element) => {
			this.setButtonAttributes($(element));
		})
	}

	addEventListeners() {
		this.$scope.find('.flickity-carousel').on('change.flickity', (event) => {
			event.preventDefault();
			let $button = $(event.currentTarget);
			let $scope = $button.closest(this.config.scope);
			this.setButtonAttributes($scope);
		});

		$(document).off('.cflickity')
			.on('click.cflickity', this.config.button, this.changeSlide.bind(this))
			.on('change.cflickity', '.flickity-carousel', (event) => {
				let $scope = $(event.currentTarget).closest(this.config.scope);
				this.setButtonAttributes($scope);
			});

		this.$scope.find(this.config.cell).on('click', (event) => this.changeSlideFromNav(event));
		if (this.$scopeVerticalNav.length > 0) {
			this.$scope.find('.flickity-main-nav').on('change.flickity', (event) => this.changeNavForSlider(event));
		}
	}

	changeSlideFromNav(event) {
		let $target = $(event.currentTarget);
		let index = $target.index();
		let $scope = $target.closest(this.config.scope);
		let $slider = $scope.find('.flickity-secondary-nav');
		let sliderMain = Flickity.data($slider[0]);
		sliderMain.select(index);
	}

	changeNavForSlider(event) {
		let $target = $(event.currentTarget);
		let $scope = $target.closest(this.config.scope);
		let $navContainer = $scope.find(this.config.verticalNav);
		let selectedCell = 'is-selected';
		$navContainer.find(`.${selectedCell}`).removeClass(selectedCell);

		let sliderMain = Flickity.data($target[0]);
		let $navCell = $navContainer.find(this.config.cell).eq(sliderMain.selectedIndex)
			.addClass(selectedCell);

		let navHeight = $navContainer.height();
		let navCellHeight = $navContainer.find(this.config.cell).outerHeight();
		let scrollY = $navCell.position().top + $navContainer.scrollTop() - (navHeight + navCellHeight) / 3;
		$navContainer.animate({scrollTop: scrollY});
	}

	changeSlide(event) {
		event.preventDefault();
		let $button = $(event.currentTarget);
		let $scope = $button.closest(this.config.scope);
		let slider = Flickity.data(($scope.find('.flickity-carousel'))[0])

		if ($button.data('flickity-button') == 'next') {
			slider.next();
		} else {
			slider.previous();
		}

		this.setButtonAttributes($scope);
	}

	setButtonAttributes($scope) {
		let slider = Flickity.data(($scope.find('.flickity-carousel'))[0]);

		if (slider.options.wrapAround) {
			return;
		}

		let $prev = $scope.find('[data-flickity-button="prev"]');
		let $next = $scope.find('[data-flickity-button="next"]');

		$prev.attr('disabled', slider.selectedIndex == 0);
		$next.attr('disabled', slider.selectedIndex == slider.slides.length - 1);
	}
}

export default CustomFlickity;
